// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Yz","summaryPar":"Zz","ratingCategories":"_z","reviewerInfo":"aA","reviewTypes":"bA","expanded":"cA"};